$(document).ready(function() {
    $('#collapseTabs .nav-link').on('click', function() {
        const selectedText = $(this).text();
        $('.filter-control').text(selectedText);
        $('#collapseTabs').collapse('hide');
    });
});